import type { FaireProductEntity } from "../../entity_types/product";

export const p_3gat7k6hpe: FaireProductEntity = {
  token: "p_3gat7k6hpe",
  type: "product",
  name: "Amber & Moss - 7.75 fl oz Room & Linen Spray",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/6b97f91b3b0d6946e9d511ea54e05e9dc749473851056da897cd21e6cccd5fbd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bf082f097c189734c63496f1d49e0d85bf5e5f32d9206f962315089448a83c00.webp",
    "https://cdn.faire.com/fastly/3633342064d10f229a96e8dbd93dfe6880295e4a435d5caf101234e32bece477.jpeg",
    "https://cdn.faire.com/fastly/0751025b22fe1e6b84ce413707f76284531e5822aed8524339635217e3312a3b.jpeg",
    "https://cdn.faire.com/fastly/3e5c4ce947afaa2f2a13a2ff4104969a32637e494f8f161f48c259c5b44dce62.jpeg",
    "https://cdn.faire.com/fastly/c8204198990372227fbca763174af767f6553facc4394d12aa05d2aec7aa9d35.jpeg",
    "https://cdn.faire.com/fastly/bc5a0c814899f777c13d6bdd067084d1a868270b280ceb550a2f0c344844dee1.jpeg",
    "https://cdn.faire.com/fastly/92c380a966cb4b7aa888644ea633272196abffc9515d6589e28c4e7bc1f82fdd.jpeg",
  ],
  priceDollars: 10,
  description:
    "A weekend in the mountains, sun gleaming through the canopy. Sage, moss, and lavender.\n\nOur Room & Linen Sprays offer an effortless, fine mist with a light fragrance! Meant for daily use on bedsheets, pillows, couches - anywhere that needs a bit of a boost. \n\nFragrance lasts longest when applied directly onto fabrics, especially any with a thicker weave.\n\nEach 7.75 oz amber bottle contains water, phthalate-free premium fragrance oil (body safe), and two cosmetic-grade preservatives meant to maintain quality and prolong shelf-life: phenoxyethanol and caprylyl glycol.",
  tags: [],
  msrpDollars: 22,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:59.889Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
